import * as types from './mutation-types';

export default {
  [types.SET_MANAGER_FILTER](state, managerId) {
    state.managerFilter = managerId;
  },
};
